import { downgradeComponent } from "@angular/upgrade/static";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import "angular-drag-and-drop-lists";
import { ReportsNavigationModule } from "./reports.navigation";
import { ExpensesComponent } from "./_components/expensesV2/expenses.component";
import { TimePickerComponent } from "./_components/parameters/timePicker.component";
import { ReportCardComponent } from "./_components/report-card/report-card.component";
import { ReportCategorySelectorComponent } from "./_components/report-category-selector/report-category-selector.component";
import { ReportColumnHeadersSelectorComponent } from "./_components/report-column-headers-selector/report-column-headers-selector.component";
import { ReportFiltersComponent } from "./_components/report-filters/report-filters.component";
import { ReportParametersComponent } from "./_components/report-parameters/report-parameters.component";
import { ReportScheduleEditorComponent } from "./_components/report-schedule-editor/report-schedule-editor.component";
import { ReportSchedulesComponent } from "./_components/report-schedules/report-schedules.component";
import { FormStatusIndicatorComponent } from "./_components/reportBuilder/formStatusIndicator.component";
import { NewReportColumnSelectorComponent } from "./_components/reportBuilder/newReportColumnSelector/newReportColumnSelector.component";
import { ReportBuilderComponent } from "./_components/reportBuilder/reportBuilder.component";
import { ReportBuilderListComponent } from "./_components/reportBuilder/reportBuilderList.component";
import { ReportColumnComponent } from "./_components/reportBuilder/reportColumn/reportColumn.component";
import { TableColumnSelectorComponent } from "./_components/reportBuilder/tableColumnSelector/tableColumnSelector.component";
import { RowDataSourceSelectorComponent2 } from "./_components/row-data-source-selector2/row-data-source-selector2.component";
import { ReportHistoryPageComponent } from "./_routes/report-history-page/report-history-page.component";
import { ReportHistoryViewComponent } from "./_routes/report-history-view/report-history-view.component";
import { ReportListPageComponent } from "./_routes/report-list-page/report-list-page.component";
import { ReportSchedulePageComponent } from "./_routes/report-schedule-page/report-schedule-page.component";
import { ReportViewComponent } from "./_routes/report-view/report-view.component";
import { DynamicReportService } from "./_services/dynamicReports.service";

export class Config {
    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {

        $stateProvider.state(ReportsNavigationModule.ParentRoot, {
            abstract: true,
            url: "/reports",
            redirectTo: ReportsNavigationModule.ReportList,
            views: { "module-navigation": {} },
            data: { translation: 'Common.Reporting', subtitleTranslationKey: "Reports.ReportListPageSubtitle" }
        });

        $stateProvider.state(ReportsNavigationModule.ReportSchedules, {
            url: "/schedules",
            views: { "content@app": { component: "reportSchedulePage" } },
            data: { translation: 'Reports.ReportSchedules' }
        });

        $stateProvider.state(ReportsNavigationModule.ReportList, {
            url: "/list",
            views: { "content@app": { component: "reportListPage" } },
            data: { translation: 'Common.Reports', subtitleTranslationKey: "Reports.ReportListPageSubtitle" }
        });

        $stateProvider.state(ReportsNavigationModule.Expenses, {
            url: "/expenses",
            views: { "content@app": { component: "expenses" } },
            data: { translation: 'Expenses.Title', subtitleTranslationKey: "Expenses.Subtitle" }
        });

        $stateProvider.state(ReportsNavigationModule.History, {
            url: "/history",
            views: { "content@app": { component: "reportHistoryPage" } },
            data: { translation: 'Common.History', subtitle: "" }
        });



        this.routeConfigHelperProvider.createDetailStateWithBoundParams({
            stateName: `${ReportsNavigationModule.ViewReport}`,
            bindingName: "reportId",
            component: "reportView",
            breadcrumbNameResolverKey: "reportNameKey",
            queryParamsNames: ['historyId']
        });

        this.routeConfigHelperProvider.createDetailStateWithBoundParams({
            stateName: `${ReportsNavigationModule.History}.view`,
            translation: "Common.History",
            bindingName: "reportHistoryId",
            component: "reportHistoryView",
            breadcrumbNameResolverKey: "reportNameKey"
        });
    }
}

angular
    .module("app.components.dynamicreports", ["app.directives", "ngMaterial", "dndLists"])
    .config(Config)

    .service("dynamicReportService", DynamicReportService)

    .component("formStatusIndicator", new FormStatusIndicatorComponent())

    .component("reportBuilder", new ReportBuilderComponent())
    .component("reportBuilderList", new ReportBuilderListComponent())
    .directive("reportCard", downgradeComponent({ component: ReportCardComponent }))
    .directive("reportSchedules", downgradeComponent({ component: ReportSchedulesComponent }))
    .directive("reportScheduleEditor", downgradeComponent({ component: ReportScheduleEditorComponent }))

    .directive("reportCategorySelector", downgradeComponent({ component: ReportCategorySelectorComponent }))
    .component("reportColumn", new ReportColumnComponent())
    .component("newReportColumnSelector", new NewReportColumnSelectorComponent())
    .component("tableColumnSelector", new TableColumnSelectorComponent())

    .component("expenses", new ExpensesComponent())

    .component("timePicker", new TimePickerComponent())

    .directive("reportFilters", downgradeComponent({ component: ReportFiltersComponent }))
    .directive("reportParameters", downgradeComponent({ component: ReportParametersComponent }))
    .directive("reportColumnHeadersSelector", downgradeComponent({ component: ReportColumnHeadersSelectorComponent }))

    .directive("reportListPage", downgradeComponent({ component: ReportListPageComponent }))
    .directive("reportHistoryPage", downgradeComponent({ component: ReportHistoryPageComponent }))
    .directive("reportView", downgradeComponent({ component: ReportViewComponent }))
    .directive("reportSchedulePage", downgradeComponent({ component: ReportSchedulePageComponent }))

    .directive("reportSchedules", downgradeComponent({ component: ReportSchedulePageComponent }))
    .directive("rowDataSourceSelector2", downgradeComponent({ component: RowDataSourceSelectorComponent2 }))
    .directive("reportHistoryView", downgradeComponent({ component: ReportHistoryViewComponent }))
    ;
